export default __webpack_public_path__ + "static/media/img4.849711d3.jpg";